var _defs, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFuriaTravelShadow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 9,
    viewBox: "0 0 42 9",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "furia-travel-shadow-a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E0E3E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BDC2C6"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1044,
    cy: 2898.5,
    fill: "url(#furia-travel-shadow-a)",
    rx: 21,
    ry: 4.5,
    transform: "translate(-1023 -2894)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFuriaTravelShadow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/furia-travel-shadow.8abfae26.svg";
export { ForwardRef as ReactComponent };